/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon[_nghost-%COMP%], .icon   [_nghost-%COMP%]{display:inline-block;width:24px;height:24px}.mat-icon[_ngcontent-%COMP%]{width:100%;height:100%}img[_ngcontent-%COMP%]{max-width:100%;max-height:100%;height:auto;-o-object-fit:cover;object-fit:cover;margin:auto}"];
export { styles as styles };
